module.exports = __webpack_public_path__ + "static/media/tamarind-hills.a4527e97.jpeg";